import { fleetManagementApi, useActiveProject } from '@nx/state';
import { useCallback } from 'react';

export type Action = 'read' | 'write';
export type Resource =
  | 'projects'
  | 'dbmss'
  | 'servers'
  | 'databases'
  | 'database_instances'
  | 'tokens'
  | 'plugins'
  | 'connect'
  | 'report'
  | 'metrics'
  | 'config';

export const usePermissions = () => {
  const activeProject = useActiveProject();
  const { data: permissions } = fleetManagementApi.endpoints.getPermissions.useQuery(activeProject.id);

  const isAllowed = useCallback(
    (resource: Resource, action: Action) => {
      return permissions?.[`${resource}:${action}`] ?? false;
    },
    [permissions],
  );

  return { isAllowed };
};
